module.exports = __webpack_public_path__ + "static/media/openBoxIcon.427512e4.svg";